// Les sauvegardes et restaurations se font désormais via l'API du serveur
// pour garantir que toutes les données (y compris celles en mémoire) sont incluses.

export const exportData = async () => {
  try {
    const response = await fetch('/api/admin/backup-data');
    if (!response.ok) throw new Error('Erreur lors de la récupération des données');
    const data = await response.json();
    return JSON.stringify(data, null, 2);
  } catch (error) {
    console.error("Erreur lors de l'exportation des données:", error);
    throw error;
  }
};

export const importData = async (jsonData: string) => {
  try {
    const data = JSON.parse(jsonData);
    const response = await fetch('/api/admin/restore-data', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Erreur lors de la restauration');
    }
  } catch (error) {
    console.error("Erreur lors de la restauration des données:", error);
    throw error;
  }
};
